import { render, staticRenderFns } from "./hist_year.vue?vue&type=template&id=31f7bd65"
import script from "./hist_year.vue?vue&type=script&lang=js"
export * from "./hist_year.vue?vue&type=script&lang=js"
import style0 from "./hist_year.vue?vue&type=style&index=0&id=31f7bd65&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports